module.exports = __webpack_public_path__ + "img/metamask.898f6c15.png";